import { MatDialog } from "@angular/material/dialog";
import { FormDataV2 } from "../../form-v2/form-model/FormDataV2";
import { FormV2ServiceService } from "../../form-v2/form-v2-service.service";
import { DeliveryAddress } from "../../shared/models/form/delivery-address.model";
import { environment } from 'src/environments/environment';
import { Order, Parameter_Dif } from "./Order";
import { Router } from "@angular/router";
import { Parameter_Plus } from "src/app/shared/models/form-model/models/form-controlls.model";

export class Inspector {
    public active:boolean = false;
    public orders: Order[] = [];
    
     private start:number;
     public FormData:FormDataV2;
     private formService: FormV2ServiceService;
     public dialog: MatDialog;
    router: Router;
    koniec: string = null;
    test: boolean = false;
    // console.log(`Czas wykonania: ${(end - start).toFixed(2)} ms`);
    constructor(){
        this.active = environment.InspectorActive;
        this.test = false; //environment.isDevVersion;
        if(this.active){
            // console.log("Inspektor", this.active);
            this.loadOrdersFromStorage();
        }
    }
    Init( FormData:FormDataV2,  formService: FormV2ServiceService, dialog: MatDialog, router:Router){
        this.start = Date.now();
        // console.log("start", this.start);
        if(this.active){
            this.formService = formService;
            this.FormData = FormData;
            this.dialog = dialog;
            this.router = router;
            setTimeout(() => { 
                if(this.active){
                    this.DodajError(this.FormData.typ_test, this.FormData.orderId, "TimeOut", "Przekroczono 20min"); 
                }
                }, 1000 * 60 * 20);
        }
    }
  Check() {
    if(this.active){

        this.start = performance.now();
        this.FormData.next(null, this.formService, 'Adres', false, this.dialog);
    }
  }
  PoKroku(){
     if(this.active){
        this.FormData.next(null, this.formService, 'Adres', false, this.dialog);
        const end = performance.now();
        // console.log(`Czas wykonania: ${(end - this.start).toFixed(2)} ms`);
    }
  }
  saveOrdersToStorage(): void {
  try {
  // console.log("zapisuje", this.orders);
    const json = JSON.stringify(this.orders);
    localStorage.setItem("lista_zlecen", json);
  } catch (error) {
    console.error('Błąd zapisu do localStorage', error);
  }
}

loadOrdersFromStorage(): void {
  try {
    const json = localStorage.getItem("lista_zlecen");

  //// console.log("wczytuje", json);
    if (!json) {
      this.orders = [];
      return;
    }

    this.orders = JSON.parse(json);
  } catch (error) {
    console.error('Błąd odczytu z localStorage', error);
    this.orders = [];
  }
}

    DodajError(typ, orderId, tresc: string, details: any) {
        
        var en = Date.now();
        // console.log("stop", en,  (en - this.start));
        this.koniec = `${((en - this.start) / 1000).toFixed(2)} s`;
        if(this.active){
            this.active = false;
            var end = Date.now();
            this.loadOrdersFromStorage();
            var order = this.orders.find(x => x.orderNumber.trim() == orderId.trim());
            // console.log("Error",orderId, tresc, details, order);
            if(typ == "N"){
                    // console.log("przechodzi do starej");
                    order.newTechTime = end - this.start;
                    order.status = "Przetwarzanie (stara tech)";
                    order.statusDes = "Błąd (nowa tech)";
                    order.notes = tresc;
                    // window.open('/Testuj/S/Copy/FR/' + order.orderNumber); //, '_self');
                    order.start = Date.now();
                    order.details = details;
                    this.saveOrdersToStorage();
                    window.open(`/Testuj/S/Copy/FR/${ order.orderNumber}`);
                    window.close();
                    // this.router.navigateByUrl(`/Testuj/S/Copy/FR/${ order.orderNumber}`);
            } else if(typ == "S"){
                    // console.log("przechodzi do kolejnej");
                    //// console.log(`Czas wykonania: ${(end - this.start).toFixed(2)} ms`);
                    order.oldTechTime = end - this.start;
                    order.notes += ","+tresc;
                    order.status = "Zakończono";
                    order.statusDes += ",Błąd (stara tech)";
                    order.detailsS = details;
                    order.sync = true;
                    this.saveOrdersToStorage();
                    window.open('/Testuj/N/Copy/FR/0');
                    window.close();
            }
        }
        
    }
 
    DodajKoniec(typ, orderId: any) {
        
        var en = Date.now();
        // console.log("stop", en,  (en - this.start));
        this.koniec = `${((en - this.start) / 1000).toFixed(2)} s`;

        if(this.active){
            this.active = false;
            this.loadOrdersFromStorage();
            // console.log("Koniec");
            var end = Date.now();
            var order = this.orders.find(x => x.orderNumber.trim() == orderId.trim());
            if(order != null){
                if(typ == "N"){
                        //// console.log(`Czas wykonania: ${(end - this.start).toFixed(2)} ms`);
                        if(this.start != null){
                            order.newTechTime = en - this.start;
                        }
                        order.statusDes = "Sukcess (nowa tech)";
                        order.status = "Przetwarzanie (stara tech)";
                        order.newTechParams = this.FormData.GetAllParams();
                        order.start = Date.now(); 
                        this.saveOrdersToStorage();
                        // console.log("otwiera nowa kartę");
                        window.open(`/Testuj/S/Copy/FR/${ order.orderNumber}`);
                        window.close();
                } else if(typ == "S"){
                        //// console.log(`Czas wykonania: ${(end - this.start).toFixed(2)} ms`);
                        if(this.start != null){
                            order.oldTechTime =  en - this.start;
                        }
                        order.status = "Zakończono";
                        order.statusDes += ", Zakończono test";
                        order.oldTechParams = this.FormData.GetAllParams();
                        this.wyliczRoznice(order);
                        order.sync = true;
                        this.saveOrdersToStorage();
                        
                        window.open('/Testuj/N/Copy/FR/0');
                        window.close();
                } else {
                        order.sync = true;
                        this.saveOrdersToStorage();
                }
            } else {
                window.open('/Testuj/N/Copy/FR/0');
                window.close();
            }
            
        }
        
        
    }
    
    wyliczRoznice(order:Order) {
        
        order.ParamsDif = [];
        if(order.newTechParams!= null && order.oldTechParams != null){
            order.newTechParams.forEach(n => {
                var o = order.oldTechParams.find(x => x.Key == n.Key && x.Module == n.Module && x.Position == n.Position);
                if(o != null ){
                    if(n.Value != o.Value){
                        if(o.Key != "TechVersion" && !o.Key.includes("Plik_") && o.Key != "ElektrykaFR" && o.Key != "Elektryka_FR120V" ){
                            order.ParamsDif.push(this.dodajParam(n, "różne Value (Nowe: "+n.Value+"!= Stare: "+o.Value+")"));
                        }
                    }
                    o.Wystapil = true;
                } else {
                    order.ParamsDif.push(this.dodajParam(n, "brak parametru w starej technologii"));
                }
            });
            var sOrder = order.oldTechParams.filter(x => !x.Wystapil);
            sOrder.forEach(s => {
                order.ParamsDif.push(this.dodajParam(s, "brak parametru w nowej technologii"));
            });
        }  
        
    }
    dodajParam(param:Parameter_Plus, podod:string){
        var p = new Parameter_Dif();
        p.Key = param.Key;
        p.Module = param.Module;
        p.Position = param.Position;
        p.Diffrence = podod;
        return p;
    }
   getNextOrder(typ: any): any {
    this.loadOrdersFromStorage();
    var czas = Date.now() - (1000 * 60 * 30); 
    for (var i = 0; i< this.orders.length;i++) { 
        if(this.orders[i].status == "Nowe" || (this.orders[i].start != null && this.orders[i].start < czas)){
            if(typ == "N"){
                this.orders[i].status = "Przetwarzanie (Nowa tech)";
            } else {
                this.orders[i].status = "Przetwarzanie (Stara tech błąd)";
                this.orders[i].sync = true;
            }
        this.orders[i].start = Date.now();
        // window.open('/Testuj/N/Edit/FR/' + this.orders[i].orderNumber, '_blank');
        this.saveOrdersToStorage();
        return this.orders[i].orderNumber;
        }
    };
    window.close();
  }
}
